import { render, staticRenderFns } from "./EventOrderDetail.vue?vue&type=template&id=6294b029&scoped=true"
import script from "./EventOrderDetail.vue?vue&type=script&lang=js"
export * from "./EventOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./EventOrderDetail.vue?vue&type=style&index=0&id=6294b029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6294b029",
  null
  
)

export default component.exports